import { writable, get } from 'svelte/store';
import { loadSurveyList } from '../api/survey-search.api';
import { createUrlParamsString, updateUrlParam } from '../../../core/helpers/url.helper';
import { scrollToElement, windowPushHistory } from '../../../core/helpers/window.helper';
export default class SurveySearchService {
    constructor(dataProvider) {
        this._dataProvider = dataProvider;
        this._pager = writable({ page: 1, perPage: 10 });
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._list = writable([]);
        this._total = writable(0);
        this._error = writable(false);
        this._processing = writable(false);
        this._active = writable(false);
        this._isFilterActive = writable(false);
        this.submitFromUrl();
    }
    submitSearch() {
        const params = {
            q: this._dataProvider.searchString,
            kategorie: this._dataProvider.kategorie,
            order: this._dataProvider.order,
        };
        windowPushHistory(createUrlParamsString(params));
        this.setPage(1);
        this._active.set(true);
        this.loadSearchResults();
    }
    goToPage(page) {
        windowPushHistory(updateUrlParam("strana", page));
        this.setPage(page);
        this.scrollToFilter();
        this.loadSearchResults();
    }
    changePageSize(pageSize) {
        windowPushHistory(updateUrlParam("pocet", pageSize));
        this.setPageSize(pageSize);
        this.goToPage(1);
    }
    sort() {
        windowPushHistory(updateUrlParam("strana", 1));
        this.setPage(1);
        this.loadSearchResults();
    }
    submitFromUrl() {
        // this._dataProvider.searchString = this._dataProvider.searchParameterFromUrl;
        // this._dataProvider.kategorie = this._dataProvider.kategorieParameterFromUrl;
        // this._dataProvider.order = this._dataProvider.orderParameterFromUrl;
        // this._dataProvider.orderDirection = this._dataProvider.orderDirectionParameterFromUrl;
        this._dataProvider.searchString = "";
        this._dataProvider.type = "";
        const urlPage = this._dataProvider.pageParameterFromUrl;
        if (urlPage) {
            this.setPage(urlPage);
        }
        const urlPageSize = this._dataProvider.pageSizeParameterFromUrl;
        if (urlPageSize) {
            this.setPageSize(urlPageSize);
        }
        this._active.set(true);
        this.loadSearchResults();
    }
    loadSearchResults() {
        this._processing.set(true);
        const filterParams = {
            categoryId: this.transformAll(this.dataProvider.kategorie),
            published: JSON.stringify(this.dataProvider.published),
            query: this.dataProvider.searchString,
            groupId: this.dataProvider.groupId,
            showSiteUrl: this.dataProvider.showSiteUrl,
            order: this.dataProvider.order,
            orderDirection: this.dataProvider.orderDirection,
            pager: this.pager,
            public: this.dataProvider.type === "VEREJNE" ? true : this.dataProvider.type === "BRNO_ID" ? false : undefined
        };
        loadSurveyList(filterParams)
            .then((response) => {
            this._list.set(response.results);
            this._pager.set(Object.assign(Object.assign({}, this.pager), { total: response.total }));
            this._total.set(response.total);
            this._error.set(false);
            this._isFilterActive.set(!!(filterParams.categoryId || filterParams.query));
            // @ts-ignore
            setTimeout(() => removeClickFocus(), 100);
        })
            .catch(() => this._error.set(true))
            .finally(() => this._processing.set(false));
    }
    scrollToFilter() {
        scrollToElement(this.dataProvider.filterEl);
    }
    setPage(page) {
        this._pager.set(Object.assign(Object.assign({}, this.pager), { page }));
    }
    setPageSize(perPage) {
        this._pager.set(Object.assign(Object.assign({}, this.pager), { perPage }));
    }
    transformAll(value) {
        return (value === "vse") ? "" : value;
    }
    get dataProvider() {
        return this._dataProvider;
    }
    get listSubs() {
        return this._list;
    }
    get activeSubs() {
        return this._active;
    }
    get isFilterActiveSubs() {
        return this._isFilterActive;
    }
    get totalSubs() {
        return this._total;
    }
    get errorSubs() {
        return this._error;
    }
    get processingSubs() {
        return this._processing;
    }
    get pagerSubs() {
        return this._pager;
    }
    get pager() {
        return get(this._pager);
    }
}
